import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppStateService } from "src/app/store/app-state.service";

const POST_PATH = '/post/view-post-details';
const GROUP_PATH = '/group/view-groups/view-group-details';
const CHAT_PATH = '/messenger';

@Injectable({
  providedIn: 'root'
})
export class OpenSubjectService {
  constructor(
    private router: Router,
    private appStateService: AppStateService,
  ) {}

  public openPost(postId: number, replyId?: number) {
    if (!postId) return;

    const replyPath = !!replyId ? `?reply=${replyId}` : '';
    this.router.navigateByUrl(`${POST_PATH}/${postId}${replyPath}`);
  }

  public openGroup(groupId) {
    this.router.navigateByUrl(`${GROUP_PATH}/${groupId}`);
  }

  public openChat(userId: string) {
    const currentUserId = this.appStateService.state.currentUser?.id;
    if (!currentUserId) return;

    const userIds = [currentUserId, userId].sort();
    if (userIds.length !== 2) {
      throw new Error(`Invalid uniqueName params '${userIds}'`);
    }
    const chatId = `${userIds.join(':')}`;
    this.router.navigateByUrl(`${CHAT_PATH}/${chatId}`);
  }
} 